import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { api, errorTreatment } from "../../../../../../services/api";
import { toast } from "react-toastify";
import { LoadingContext } from "../../../../../../contexts/Loading/LoadingContext";
import { useNavigate } from "react-router-dom";

interface DataChartProps {
  show: boolean;
  changeModal: (value: boolean) => void;
  id: string;
  dash: boolean;
}

const ModalConfirmation = ({ show, changeModal, id, dash }: DataChartProps) => {
  const { changeVisibility } = useContext(LoadingContext);
  const navigate = useNavigate();

  const handleClose = () => {
    changeModal(false);
  };

  function remove() {
    changeVisibility(true);
    Promise.all([api.delete(`/dashboards/${id}/configurations`)])
      .then(() => {
        changeVisibility(false);
        toast.success("Remoção realizada com sucesso!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        window.document.getElementById("user-page" + id)?.remove();
        if(dash){
          navigate("/");
          handleClose();
        }else{
          window.location.reload();
          handleClose();
        }
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return show ? (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Remoção</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Não será possível recuperá-lo após a exclusão!
        <br />
        Tem certeza que deseja fazer a exclusão?
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" onClick={handleClose}>
          Não excluir
        </Button>
        <Button type="button" variant="primary" onClick={remove}>
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default ModalConfirmation;
